import type { IApplicationTableColumn } from '../../api/applications/state.types'

// Used before the first successful schema response; API metadata always takes precedence.
export const DEFAULT_APPLICATION_TABLE_COLUMNS: IApplicationTableColumn[] = [
    {
        "name": "application_id",
        "type": "number",
        "label": "Идентификатор заявки"
    },
    {
        "name": "is_deleted",
        "type": "boolean"
    },
    {
        "name": "is_repeat",
        "type": "boolean"
    },
    {
        "name": "is_black_list",
        "type": "boolean"
    },
    {
        "name": "data_base",
        "type": "text",
        "label": "База данных сайта"
    },
    {
        "name": "site_name",
        "type": "text",
        "label": "Название по русски"
    },
    {
        "name": "application_type_id",
        "type": "number",
        "label": "Идентификатор типа заявки (dict_application_type)"
    },
    {
        "name": "application_type_name",
        "type": "text",
        "label": "Наименование типа заявки",
        "filterType": "select"
    },
    {
        "name": "application_source_id",
        "type": "number",
        "label": "От куда прилетела заявка"
    },
    {
        "name": "application_source_name",
        "type": "text",
        "label": "Наименование истояника заявки",
        "filterType": "select"
    },
    {
        "name": "date_create",
        "type": "datetime",
        "label": "Дата создания заявки"
    },
    {
        "name": "date_change",
        "type": "datetime",
        "label": "Дата изменения заявки"
    },
    {
        "name": "client_name",
        "type": "text",
        "label": "Имя клиента"
    },
    {
        "name": "client_phone",
        "type": "text",
        "label": "Телефон клиента"
    },
    {
        "name": "client_rating",
        "type": "number",
        "label": "Оценка клиента (на сколько он сговорчивый)"
    },
    {
        "name": "client_phone_clean",
        "type": "text"
    },
    {
        "name": "client_email",
        "type": "text",
        "label": "Электронная почта клиента"
    },
    {
        "name": "preferred_contact_method",
        "type": "text"
    },
    {
        "name": "course_id",
        "type": "number",
        "label": "Идентификатор курса"
    },
    {
        "name": "course_name",
        "type": "text",
        "label": "Наименование курса",
        "filterType": "select"
    },
    {
        "name": "page_canonical",
        "type": "text",
        "label": "Ссылка на лэндинг курса"
    },
    {
        "name": "requirement_id",
        "type": "number",
        "label": "Идентификатор требования к образованию"
    },
    {
        "name": "requirement_name",
        "type": "text",
        "label": "Наименование требования к образованию",
        "filterType": "select"
    },
    {
        "name": "course_program_id",
        "type": "number",
        "label": "Идентификатор программы"
    },
    {
        "name": "program_id",
        "type": "number",
        "label": "Идентификатор программы"
    },
    {
        "name": "program_name",
        "type": "text",
        "label": "Имя программы",
        "filterType": "select"
    },
    {
        "name": "volume_hours",
        "type": "number",
        "label": "Обьем часов по программе"
    },
    {
        "name": "sum",
        "type": "number",
        "label": "Полная стоимость курса"
    },
    {
        "name": "sum_month",
        "type": "number"
    },
    {
        "name": "duration_education",
        "type": "number",
        "label": "Длительность обучения"
    },
    {
        "name": "attestation_type_id",
        "type": "number",
        "label": "Идентификатор типа итоговой аттестации (dict_attestation_type)"
    },
    {
        "name": "attestation_type_name",
        "type": "text",
        "label": "Наименование итоговой аттестации",
        "filterType": "select"
    },
    {
        "name": "start_education_date",
        "type": "text",
        "label": "Дата начала обучения"
    },
    {
        "name": "end_education_date",
        "type": "text",
        "label": "Дата окончания обучения"
    },
    {
        "name": "application_status_id",
        "type": "number",
        "label": "Идентификатор статуса заявки (dict_application_statuses)"
    },
    {
        "name": "application_status_name",
        "type": "text",
        "label": "Наименование статуса заявки",
        "filterType": "select"
    },
    {
        "name": "application_status_color",
        "type": "text",
        "label": "Цвет статуса заявки"
    },
    {
        "name": "date_next_call",
        "type": "text",
        "label": "Дата отложенного звонка"
    },
    {
        "name": "time_next_call",
        "type": "text",
        "label": "Время отложенного звонка"
    },
    {
        "name": "application_comment",
        "type": "text",
        "label": "Комментарий к заявке"
    },
    {
        "name": "user_demo_name_id",
        "type": "text",
        "label": "Имя пользователя для демо доступа"
    },
    {
        "name": "user_demo_hash_id",
        "type": "text",
        "label": "Хэш имени пользовтеля для демо доступа "
    },
    {
        "name": "user_demo_crm",
        "type": "number"
    },
    {
        "name": "sms",
        "type": "text",
        "label": "Ссылка для смс"
    },
    {
        "name": "contract_count",
        "type": "number"
    },
    {
        "name": "AI_chat_GUID",
        "type": "text"
    },
    {
        "name": "application_origin",
        "type": "text",
        "label": "Источник заявки",
        "filterType": "select"
    }
]
